import { Constructor } from '@skylab-shared/types';

export const ListenersRegistry = <T extends Constructor<{}, U>, U extends any[]>(Base: T) => {
    return class extends Base {
        public deregisterFunctions: Function[] = [];

        public registerListening(f: Function): void {
            this.deregisterFunctions.push(f);
        }

        public deregisterAllListeners(): void {
            this.deregisterFunctions.forEach(f => f());
            this.deregisterFunctions.length = 0;
        }
    };
};
